var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_860_2885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.39093 15.6938L3.94241 18.2531L3.92319 15.3L0.39093 15.6938Z",
    fill: "#933319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9702 8.92236V34.2913C29.9702 35.2353 29.2052 36 28.2616 36H5.65105C4.70746 36 3.94238 35.2353 3.94238 34.2913V1.70901C3.94238 0.765073 4.70746 0 5.65105 0H20.426L29.9702 8.92236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9682 7.16479H0.708828C0.317353 7.16479 0 7.48215 0 7.87362V15.0604C0 15.4519 0.317353 15.7692 0.708828 15.7692H16.9682C17.3597 15.7692 17.677 15.4519 17.677 15.0604V7.87362C17.677 7.48215 17.3597 7.16479 16.9682 7.16479Z",
    fill: "#F15A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95898 14.0801V9.08374H4.5328C4.80774 9.08374 5.06381 9.10924 5.30067 9.16025C5.53752 9.21125 5.74259 9.29789 5.91552 9.41981C6.0888 9.54209 6.22364 9.70139 6.32041 9.89737C6.41718 10.0934 6.46574 10.3365 6.46574 10.6268C6.46574 10.9017 6.41718 11.1414 6.32041 11.3451C6.22364 11.5487 6.08984 11.7182 5.91936 11.853C5.74853 11.9879 5.54766 12.0874 5.31569 12.151C5.08372 12.2146 4.83324 12.2464 4.56319 12.2464H3.84528V14.0798H2.95898V14.0801ZM3.84528 11.5362H4.49472C5.228 11.5362 5.59482 11.2333 5.59482 10.6272C5.59482 10.3114 5.49945 10.0937 5.30835 9.97388C5.11726 9.8544 4.83603 9.79431 4.46433 9.79431H3.84563V11.5362H3.84528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40513 14.0801V9.08374H8.97895C9.25389 9.08374 9.50996 9.10924 9.74682 9.16025C9.98367 9.21125 10.1887 9.29789 10.3617 9.41981C10.5346 9.54209 10.6698 9.70139 10.7666 9.89737C10.8633 10.0934 10.9119 10.3365 10.9119 10.6268C10.9119 10.9017 10.8633 11.1414 10.7666 11.3451C10.6698 11.5487 10.536 11.7182 10.3655 11.853C10.1947 11.9879 9.99381 12.0874 9.76184 12.151C9.53022 12.2146 9.27939 12.2464 9.00934 12.2464H8.29108V14.0798H7.40479L7.40513 14.0801ZM8.29143 11.5362H8.94087C9.67415 11.5362 10.041 11.2333 10.041 10.6272C10.041 10.3114 9.9456 10.0937 9.7545 9.97388C9.56341 9.8544 9.28218 9.79431 8.91048 9.79431H8.29178V11.5362H8.29143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7145 14.0801V9.83239H11.2707V9.08374H15.0447V9.83239H13.6008V14.0801H12.7145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9702 8.92236V9.18646H21.4674C20.8183 9.18646 20.2919 8.66 20.2919 8.01056V0H20.426L29.9702 8.92236Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 18.5474H8.75433V19.9615H25.1587V18.5474Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 21.8062H8.75433V23.2203H25.1587V21.8062Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 25.0647H8.75433V26.4789H25.1587V25.0647Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 28.3235H8.75433V29.7376H25.1587V28.3235Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1587 31.5823H8.75433V32.9964H25.1587V31.5823Z",
    fill: "#E6E7E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_860_2885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9702,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptMessage);
export default __webpack_public_path__ + "static/media/ppt_message.c8f23433814b1a2a45d13b1e143245c0.svg";
export { ForwardRef as ReactComponent };